import { render } from "./MegaMenu.vue?vue&type=template&id=46af5236&scoped=true"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"

import "./MegaMenu.vue?vue&type=style&index=0&id=46af5236&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46af5236"]])

export default __exports__